import { get } from 'lodash';

export const getHoldProductCustomerTypes = state => get(state, 'holdProduct.product.customerTypes', undefined);



// WEBPACK FOOTER //
// ./src/selectors/hold_product_selectors.js